import React, { useState } from 'react';
import { Grid, Button, makeStyles, colors } from '@material-ui/core';

import SingleFormPage from './SingleFormPage';

const useStyles = makeStyles({
  undoButton: {
    marginBottom: -16,
    color: colors.grey[50],
    backgroundColor: colors.red[900],
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
  submitButton: {
    backgroundColor: colors.red[400],
    color: colors.grey[50],
    '&:hover': {
      backgroundColor: colors.red[100],
    },
    '&:disabled': {
      color: colors.grey[50],
      backgroundColor: colors.red[100],
    },
  },
});

const EditSingleFormPage = ({
  inputValue,
  onInputChange,
  onInputSubmit,
  validator,
  Input,
  submitButtonLabel,
}) => {
  const [firstValue] = useState(inputValue);
  const classes = useStyles();

  const _onUndoButtonClick = (onChange) => onChange(firstValue);

  return (
    <SingleFormPage
      inputValue={inputValue}
      onInputChange={onInputChange}
      onInputSubmit={onInputSubmit}
      validator={validator}
      Input={Input}
      submitButtonLabel={submitButtonLabel}
      renderHeader={(onChange) => {
        return (
          <Grid container justify="flex-end">
            <Grid item>
              <Button
                onClick={() => _onUndoButtonClick(onChange)}
                size="small"
                className={classes.undoButton}
              >
                <b>UNDO</b>
              </Button>
            </Grid>
          </Grid>
        );
      }}
    ></SingleFormPage>
  );
};

export default EditSingleFormPage;
